class MyLevelFullModalController {

    constructor() {

        this.template = Handlebars.compile($("#myLevelFullModal").html());
        this.menuTemplate = Handlebars.compile($("#fullModalMenu").html());

        $(document).off('click', '#openLevelsModalBtn');
        $(document).on('click', '#openLevelsModalBtn', function(e) {
            e.preventDefault();
            api.getWorldLevels(world.token);
        });

    };

    draw() {
        api.getLevelProgress(this.onLevelInfoResponse.bind(this));
    };

    onLevelInfoResponse(response) {
        if (response.success) {
            response.result.user_progress *=100;
            baseController.resetStackableOrder();
            baseController.stackSimpleMenu({ title: 'TR_MI_NIVEL' }, this.menuTemplate);

            var levelIcon = customIcons["UNKNOWN_LEVEL_LIST"];
            var context = response.result;
            context["levelIcon"] = levelIcon;

            baseController.stackSimpleContent(this.template, context, 'GAME');
            $('#profile-level-icon-modal').circliful();

            let height = 50;

            if ($(window).width() <= 420) {
                height = 40;
            }

            $('.level-icon-title').dotdotdot({
                height: height,
                watch: 'true',
                truncate: 'letter'
            });

        }
    }
}
